
/**
 * 竞拍：**按关卡分期**，不是一组全局参数。
 *
 * 一关一条时间线，一期竞拍下一期的地标舞台展示权：
 * 竞拍期结束的那一刻起，展示期开始，两者等长。所以展示期不单独配，
 * 由竞拍期推出——两处各填一次，早晚会填出「展示期比竞拍期先结束」这种东西。
 *
 * 时间一律 UTC 毫秒，展示按租户时区（见 lib/time.ts）。
 */
export interface AuctionPeriod {
  id: string;
  /** 竞价开始 / 结束，UTC 毫秒 */
  bidStartMs: number | null;
  bidEndMs: number | null;
  /** 最低加价比例，0.1 = 当前价 +10% */
  minInc: number | null;
  /** 中拍后展示期内本城火花加成比例 */
  sparkBonus: number | null;
  enabled: boolean;
}

export interface AuctionDefaults {
  bidStartMs: number | null;
  bidEndMs: number | null;
  minInc: number | null;
  sparkBonus: number | null;
}

/** 关卡 id → 该关的历期，最后一条是最新一期 */
export type AuctionMap = Record<number, AuctionPeriod[]>;

const DAY = 86400000;

export const defaultAuction = (nowMs: number): AuctionDefaults => ({
  bidStartMs: nowMs,
  bidEndMs: nowMs + 30 * DAY,
  minInc: 0.1,
  sparkBonus: 0.1,
});

let seq = 0;
export function newPeriod(d: AuctionDefaults): AuctionPeriod {
  seq += 1;
  return { id: `ac${seq}`, bidStartMs: d.bidStartMs, bidEndMs: d.bidEndMs, minInc: d.minInc, sparkBonus: d.sparkBonus, enabled: true };
}

/** 首次进页面时给每关铺一期，方便看清结构；真数据来了由接口覆盖 */
/*
 * buildAuctions() 已删除：它给每关铺一期假竞拍。竞拍数据必须来自后端，
 * 前端擅自铺一期不但不是事实，还会立刻把快照弄脏。
 */
export function showWindow(p: { bidStartMs: number | null; bidEndMs: number | null }) {
  if (p.bidStartMs == null || p.bidEndMs == null) return null;
  const len = p.bidEndMs - p.bidStartMs;
  if (len <= 0) return null;
  return { startMs: p.bidEndMs, endMs: p.bidEndMs + len };
}

export const windowValid = (p: { bidStartMs: number | null; bidEndMs: number | null }) =>
  p.bidStartMs != null && p.bidEndMs != null && p.bidEndMs > p.bidStartMs;

/** 时长，拆成天 + 小时；不足一小时单独说，别显示成「0 天」 */
export function spanParts(p: { bidStartMs: number | null; bidEndMs: number | null }) {
  if (!windowValid(p)) return null;
  const ms = p.bidEndMs! - p.bidStartMs!;
  return { days: Math.floor(ms / DAY), hours: Math.floor((ms % DAY) / 3600000) };
}
